import { render, staticRenderFns } from "./AllergensConfiguration.vue?vue&type=template&id=e9ec7848&scoped=true"
import script from "./AllergensConfiguration.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllergensConfiguration.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AllergensConfiguration.vue?vue&type=style&index=0&id=e9ec7848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ec7848",
  null
  
)

export default component.exports